import React, {Suspense} from "react";
import {useTranslation, Trans} from "react-i18next";

function HeaderComponent()
{
	const {t} = useTranslation('translation');
    return <div className="home"  id="wrapper">
	<main>
	  <h2>{t('home.ex.h2')}</h2>
	  <div className="overview">
		  <h3>{t('home.ex.h3')}</h3>
		  <p>{t('home.ex.p1')}</p>
		  <div className="einblick"> <a href="beispiele.html#bagatellen"><img src="./images/6Bagatellen_Webern.png" alt="" id="bagat"/></a> </div>
		  <p className="button"><a href="ueber_uns.html">{t('home.ex.p2')}</a>.</p>
		  <p className="button"><Trans i18nKey="home.ex.p3" components={{MyLink:(<a href="beispiele.html" target="_blank" rel="noopener noreferrer">link</a>)}}/></p>
		  <p className="button"><Trans i18nKey="home.ex.p4" components={{MyLink:(<a href="rezensionen.html" target="_blank" rel="noopener noreferrer">link</a>)}}/></p>
		  <p className="button"><Trans i18nKey="home.ex.p5" components={{MyLink:(<a href="contact.php" target="_blank" rel="noopener noreferrer">link</a> )}}/></p>
	  </div>
	  <h2>Service</h2>
	  <Trans i18nKey="home.se" components={{p:<p />}}/>
  </main>
  <aside>
	  <h2>{t('home.an.h2')}</h2>
	  <h3>{t('home.an.h3')}</h3>
	  <Trans i18nKey="home.an.li" components={{li:<li />}}/>
	  <h3>{t('home.zl.h3')}</h3>
	  <Trans i18nKey="home.zl.li" components={{p:<p />,li: <li />}}/>
  </aside>
  </div>
}

function Home() {
  return (
    <Suspense fallback="loading">
	<div className="App">
		<HeaderComponent/>
	</div>
</Suspense>
  );
}

export default Home;
